import { useEffect, useState } from 'react';
import Text11 from '@sdk/components/ui/typography/Text11';
import Text14 from '@sdk/components/ui/typography/Text14';
import Column from '@sdk/components/ui/spacing/Column';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Button from '@sdk/components/ui/buttons/Button';
import FieldError from '@sdk/components/forms/components/FieldError';

import { ButtonContainer } from '@web/components/survey/ButtonContainer';
import SurveyScores from '@web/components/survey/surveyScore/SurveyScores';
import { ScoreRow } from '@web/components/survey/surveyScore/SurveyScoreStep.styles';

type Props = {
  score: number;
  onSetScore: (score: number) => void;
  submitScore: () => void;
  text?: string;
  submitLabel?: string;
};

const SurveyScoreStep = ({ score, onSetScore, submitScore, text, submitLabel }: Props) => {
  const [hasError, setHasError] = useState(false);

  const submit = () => {
    if (score) {
      submitScore();
    }

    setHasError(!score);
  };

  useEffect(() => {
    if (score) {
      setHasError(false);
    }
  }, [score]);

  return (
    <Column>
      <Text14 themeColor={ThemeColorType.gray}>
        {text || gettext('Overall, how satisfied are you with Sling?')}
      </Text14>

      <FieldError invalid={hasError} error={gettext('* Please select a score')} />

      <ScoreRow>
        <SurveyScores score={score} setScore={onSetScore} />
      </ScoreRow>
      <ScoreRow>
        <Text11 italic themeColor={ThemeColorType.iconGray}>
          {gettext('Very\ndissatisfied')}
        </Text11>
        <Text11 italic themeColor={ThemeColorType.iconGray} textAlign="right">
          {gettext('Very\nsatisfied')}
        </Text11>
      </ScoreRow>

      <ButtonContainer>
        <Button
          inactive={!score}
          buttonType={score ? ButtonType.primary : ButtonType.disabledStyle}
          onClick={submit}>
          {submitLabel ? submitLabel : gettext('Submit')}
        </Button>
      </ButtonContainer>
    </Column>
  );
};

export default SurveyScoreStep;
